import { createGetPropGetter } from '@/store/utils';

export default {
  openDetailedIssuePopupOnStart: createGetPropGetter('openDetailedIssuePopupOnStart', false),
  centralizedIssuesListForProject: createGetPropGetter('centralizedIssuesListForProject', []),
  detailedIssueForCentralizedView: createGetPropGetter('detailedIssueForCentralizedView', {}),
  centralizedIssuesListLoading: createGetPropGetter('centralizedIssuesListLoading', false),
  dashboardIssuesListLoading: createGetPropGetter('dashboardIssuesListLoading', false),
  projectIssuesListLoading: createGetPropGetter('projectIssuesListLoading', false),
  centralizedIssues: createGetPropGetter('centralizedIssues', []),
  centralizedIssuesForDashboard: createGetPropGetter('centralizedIssuesForDashboard', []),
  centralizedIssuesForProjectDetails: createGetPropGetter('centralizedIssuesForProjectDetails', []),
  centralizedIssuesListOptions: createGetPropGetter('centralizedIssuesListOptions', {}),
  issuesRunningInterval: createGetPropGetter('issuesRunningInterval', false),
  issuesProgress: createGetPropGetter('issuesProgress', 0),
  issuesRefId: createGetPropGetter('issuesRefId', ''),
  dashboardIssuesRunningInterval: createGetPropGetter('dashboardIssuesRunningInterval', false),
  dashboardIssuesProgress: createGetPropGetter('dashboardIssuesProgress', 0),
  dashboardIssuesRefId: createGetPropGetter('dashboardIssuesRefId', ''),
  projectIssuesRunningInterval: createGetPropGetter('projectIssuesRunningInterval', false),
  projectIssuesProgress: createGetPropGetter('projectIssuesProgress', 0),
  projectIssuesRefId: createGetPropGetter('projectIssuesRefId', ''),
  centralizedIssuesListSort(state, { centralizedIssuesListOptions = {} }) {
    return centralizedIssuesListOptions.sort || {};
  },
};
